import React, { Component } from 'react';
import fetch from 'cross-fetch';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import { withTranslation } from 'react-i18next';
import TextField from '../bits/TextField.jsx';
import NavBar from './NavBar.jsx';

class BasicInfoForm extends Component {
  state = {
    isLoading: false,
    errorCode: null,
  }

  nextDisabled = () => (this.props.values.email.length === 0);

  issueOtp = () => {
    const { onNext } = this.props;
    const { email } = this.props.values;

    return fetch('/users/issue-otp', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        if (response.ok) {
          onNext(false);
          return true;
        }

        throw new Error('basic_info_form.error_invalid_email');
      });
  };

  onSubmit = () => {
    const { onNext } = this.props;
    const { email } = this.props.values;

    this.setState({
      isLoading: true,
    });

    fetch('/users/check-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        throw new Error('basic_info_form.error_generic');
      })
      .then((data) => {
        switch (data.validation_result) {
          case 'email_invalid':
            throw new Error('basic_info_form.error_invalid_email');
          case 'email_taken':
            return this.issueOtp();
          default:
            // This is a new account
            onNext(true);
            return true;
        }
      })
      .catch((error) => {
        this.setState({
          errorCode: error.message,
          isLoading: false,
        });
      });
  };

  render() {
    const {
      onBack,
      values,
      handleChange,
      t,
      vineEnabled,
    } = this.props;

    return (
      <div>
        <h2>{t('basic_info_form.title')}</h2>
        <div className="form-group">
          <TextField
              id="email"
              label={t('basic_info_form.input_label')}
              value={values.email}
              onChange={handleChange('email')}
              fullWidth
              margin="normal"
              error={Boolean(this.state.errorCode)}
              helperText={t(this.state.errorCode)}
            />

          {vineEnabled && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.isAmazonReviewer}
                  onChange={e => handleChange('isAmazonReviewer')({ target: { value: e.target.checked } })}
                  name="checkedB"
                  color="primary"
                />
              }
              label={t('basic_info_form.vine_checkbox_desc')}
            />
          )}
        </div>
        <NavBar
          isLoading={this.state.isLoading}
          onNext={this.onSubmit}
          nextDisabled={this.nextDisabled()}
          onBack={onBack} />
      </div>
    );
  }
}

BasicInfoForm.propTypes = {
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  vineEnabled: PropTypes.bool.isRequired,
};

export default withTranslation('activation_wizard')(BasicInfoForm);
